import {handleResponse} from "@/services/service-helpers.ts";
import log from '@/lib/logger';

const NBH_BIRTHDAYS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/birthdays`

export interface Birthday {
    id: string
    firstName: string
    lastName: string
    dateOfBirth: string
    age: number
    isHighlighted: boolean
    isRoundBirthday: boolean
    isSenior: boolean
    isSpecialAge: boolean
}

export async function getBirthdays(
    token: string | null,
    filterType: 'month' | 'quarter' | 'year' | 'upcoming',
    year: number,
    month?: number,
    quarter?: number,
    limit?: number
): Promise<Birthday[]> {
    if (!token) {
        log.error("No token provided to request birthdays");
        return Promise.reject("No token provided");
    }

    const params = new URLSearchParams();
    params.append('filterType', filterType);
    params.append('year', year.toString());

    if (filterType === 'month' && month !== undefined) {
        params.append('month', month.toString());
    }

    if (filterType === 'quarter' && quarter !== undefined) {
        params.append('quarter', quarter.toString());
    }

    if (limit !== undefined) {
        params.append('limit', limit.toString());
    }

    const url = `${NBH_BIRTHDAYS_BASE_URL}?${params.toString()}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    });

    const result = await handleResponse<Birthday[]>(response)
    return result || []
}

export async function getUpcomingBirthdaysForDashboard(
    token: string | null,
    limit: number = 8
): Promise<Birthday[]> {
    return getBirthdays(token, 'upcoming', new Date().getFullYear(), undefined, undefined, limit);
}